export const SECTIONS_LIST = "SECTIONS_LIST"
export const SECTIONS_LIST_SUCCESS = "SECTIONS_LIST_SUCCESS"
export const SECTIONS_LIST_ERROR = "SECTIONS_LIST_ERROR"

export const SECTIONS_NEW = "SECTIONS_NEW"
export const SECTIONS_NEW_SUCCESS = "SECTIONS_NEW_SUCCESS"
export const SECTIONS_NEW_ERROR = "SECTIONS_NEW_ERROR"

export const SECTIONS_EDIT = "SECTIONS_EDIT"

export const SECTIONS_DELETE = "SECTIONS_DELETE"
export const SECTIONS_DELETE_SUCCESS = "SECTIONS_DELETE_SUCCESS"
export const SECTIONS_DELETE_ERROR = "SECTIONS_DELETE_ERROR"

export const SECTIONS_COMPANIES_LIST = "SECTIONS_COMPANIES_LIST"
export const SECTIONS_COMPANIES_LIST_SUCCESS = "SECTIONS_COMPANIES_LIST_SUCCESS"
export const SECTIONS_COMPANIES_LIST_ERROR = "SECTIONS_COMPANIES_LIST_ERROR"
